<template>
    <div>
        <div v-show="hostedFieldsLoading" class="w-full max-w-xs">
            <div class="flex w-full animate-pulse space-x-4">
                <div class="w-full space-y-5">
                    <div class="w-full">
                        <div
                            class="mb-1 h-5 w-1/6 rounded-[6px] bg-gray-300"
                        ></div>
                        <div class="h-10 w-full rounded-[6px] bg-gray-300"></div>
                    </div>

                    <div class="w-full">
                        <div
                            class="mb-1 h-5 w-1/6 rounded-[6px] bg-gray-300"
                        ></div>
                        <div class="h-10 w-full rounded-[6px] bg-gray-300"></div>
                    </div>

                    <div class="flex w-full gap-4">
                        <div class="w-[100px]">
                            <div
                                class="mb-1 h-5 w-2/6 rounded-[6px] bg-gray-300"
                            ></div>
                            <div
                                class="h-10 w-full rounded-[6px] bg-gray-300"
                            ></div>
                        </div>
                        <div class="w-[100px]">
                            <div
                                class="mb-1 h-5 w-2/6 rounded-[6px] bg-gray-300"
                            ></div>
                            <div
                                class="h-10 w-full rounded-[6px] bg-gray-300"
                            ></div>
                        </div>
                    </div>

                    <div class="flex h-10 w-full rounded-[6px] bg-gray-300"></div>

                    <div class="flex h-5 w-full rounded-[6px] bg-gray-300"></div>
                </div>
            </div>
        </div>

        <div v-show="!hostedFieldsLoading">
            <div class="relative flex w-full max-w-xs">
                <div class="w-full flex-col">
                    <label
                        class="mb-1 flex text-left text-sm font-medium leading-5 text-gray-700"
                        for="cardNumber"
                    >
                        Card Number
                    </label>
                    <div
                        id="cardNumber"
                        type="text"
                        class="h-10 w-full rounded-[6px] border border-gray-300 bg-white px-3 py-2 font-normal leading-10 shadow-button hover:bg-gray-50"
                    ></div>
                </div>
                <div
                    class="absolute -right-0.5 -top-1.5 hidden w-40 justify-between px-0.5 sm:flex"
                >
                    <img
                        src="https://d1vyenbk43iobe.cloudfront.net/application/images/payments/visa.svg"
                        class="h-[22px] w-[33px]"
                        alt=""
                    />
                    <img
                        src="https://d1vyenbk43iobe.cloudfront.net/application/images/payments/discover.svg"
                        class="h-[22px] w-[33px]"
                        alt=""
                    />
                    <img
                        src="https://d1vyenbk43iobe.cloudfront.net/application/images/payments/mastercard.svg"
                        class="h-[22px] w-[33px]"
                        alt=""
                    />
                    <img
                        src="https://d1vyenbk43iobe.cloudfront.net/application/images/payments/maestro.svg"
                        class="h-[22px] w-[33px]"
                        alt=""
                    />
                </div>
            </div>

            <div v-if="!isStripeEnabled" class="mt-5 flex w-full max-w-xs">
                <div class="w-full flex-col">
                    <label
                        class="mb-1 flex text-left text-sm font-medium leading-5 text-gray-700"
                        for="cardholderName"
                    >
                        Name on card
                    </label>
                    <div
                        id="cardholderName"
                        type="text"
                        class="h-10 w-full rounded-[6px] border border-gray-300 bg-white px-3 font-normal leading-10 shadow-button hover:bg-gray-50"
                    ></div>
                </div>
            </div>

            <div class="mt-5 flex w-full max-w-xs flex-col pb-1 sm:flex-row">
                <div class="mr-4 w-[100px] flex-col">
                    <label
                        class="mb-1 flex text-left text-sm font-medium leading-5 text-gray-700"
                        for="cardExpirationDate"
                    >
                        Expiry date
                    </label>
                    <div
                        id="cardExpirationDate"
                        type="text"
                        class="h-10 w-full rounded-[6px] border border-gray-300 bg-white px-3 py-2 font-normal leading-10 shadow-button hover:bg-gray-50"
                    ></div>
                </div>

                <div class="mt-5 w-[100px] flex-col sm:mt-0">
                    <label
                        class="mb-1 flex text-left text-sm font-medium leading-5 text-gray-700"
                        for="cardCvv"
                    >
                        Security code
                    </label>
                    <div
                        id="cardCvv"
                        type="text"
                        class="h-10 w-full rounded-[6px] border border-gray-300 bg-white px-3 py-2 font-normal leading-10 shadow-button hover:bg-gray-50"
                    ></div>
                </div>
            </div>
            <div class="mt-5 inline-flex flex-col justify-start sm:flex-row">
                <AtomicButton
                    size="md"
                    class="sm:mr-4"
                    color="yellow"
                    :disabled="loading"
                    @click="saveCard"
                >
                    Add credit card
                </AtomicButton>

                <AtomicButton
                    class="mt-4 sm:mt-0"
                    size="md"
                    color="white"
                    @click="$emit('close')"
                >
                    Cancel
                </AtomicButton>
            </div>
        </div>

        <CheckboxInput
            v-if="!hostedFieldsLoading"
            v-model:checked="cardAdditionalInformationEnabled"
            label="Provide us with more information about the cardholder"
            size="md"
            name="cardAdditionalInformation"
            class="mt-4"
        />

        <CardAdditionalInformation
            v-if="cardAdditionalInformationEnabled"
            v-model:card-additional-information="cardAdditionalInformation"
            class="mt-4 max-w-md"
        />

        <AlternativePaymentButton
            v-if="!teamFeatureDisabled('paypal') && !isStripeEnabled"
            button-id="paypal-button"
            loading-src="data:image/svg+xml;base64,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"
            :loading="loading && paypalLoading"
            active-class="bg-orange-500"
        />
    </div>
</template>

<script lang="ts" setup>
import {
    client as BraintreeClient,
    paypalCheckout as BraintreePaypalCheckout,
} from 'braintree-web';

import { create } from '@composables/useNotifications';

import ITeamCardAdditionalInformation from '@/types/Members/ITeamCardAdditionalInformation';
import useVuelidate from '@vuelidate/core';
import useFeatures from '@/composables/useFeatures';
import { useBraintreeClient } from '@/composables/useBraintree';
import { PropType } from 'vue';
import { useStripeClient } from '@/composables/useStripe';
import BillingAddress from '@/types/Subscription/BillingAddress';

const props = defineProps({
    billingAddress: {
        required: true,
        type: Object as PropType<BillingAddress>,
    },
    subscriptionType: {
        required: true,
        type: String as PropType<'pro' | 'plugin'>,
    },
});

const emit = defineEmits(['close']);

const v$ = useVuelidate();

const { teamFeatureDisabled } = useFeatures();
const isStripeEnabled = !teamFeatureDisabled('stripe');

const {
    createClient: braintreeCreateClient,
    teardownClient: braintreeTeardownClient,
    verifyCard: braintreeVerifyCard,
    paymentGatewayToken: braintreePaymentGatewayToken,
    addPaymentMethod: braintreeAddPaymentMethod,
} = useBraintreeClient(props.subscriptionType);

const { addPaymentMethod: stripeAddPaymentMethod, createHostedFields } =
    useStripeClient(props.subscriptionType);

const hostedFieldsLoading = ref(true);
const loading = ref(true);
const paypalLoading = ref(true);
const cardAdditionalInformationEnabled = ref(false);

const cardAdditionalInformation = ref<ITeamCardAdditionalInformation>({
    given_name: props.billingAddress.name
        ? props.billingAddress.name.split(' ')[0]
        : '',
    surname: props.billingAddress.name
        ? props.billingAddress.name.split(' ')[1]
        : '',
    phone_number: '',
    street_address: props.billingAddress.street,
    extended_address: '',
    locality: props.billingAddress.city,
    region: '',
    postal_code: props.billingAddress.postal_code,
    country_code:
        props.billingAddress.country !== 'EL'
            ? props.billingAddress.country
            : 'GR',
    email: props.billingAddress.email,
});

onMounted(async () => {
    if (isStripeEnabled) {
        await createHostedFields();
    } else {
        await braintreeCreateClient({ enableHostedFields: true });

        if (!teamFeatureDisabled('paypal')) {
            await preparePaypal();
        }
    }

    paypalLoading.value = false;
    loading.value = false;
    hostedFieldsLoading.value = false;
});

onUnmounted(async () => {
    await braintreeTeardownClient();
});

const cardAdditionalInfo = computed(() => {
    return cardAdditionalInformationEnabled.value && !v$.value.$invalid
        ? cardAdditionalInformation.value
        : null;
});

async function preparePaypal() {
    try {
        BraintreeClient.create({
            authorization: braintreePaymentGatewayToken.value,
        })
            .then(function (clientInstance) {
                // Create a PayPal Checkout component.
                return BraintreePaypalCheckout.create({
                    client: clientInstance,
                });
            })
            .then(function (paypalCheckoutInstance) {
                return paypalCheckoutInstance.loadPayPalSDK({
                    vault: true,
                });
            })
            .then(function (paypalCheckoutInstance) {
                return paypal
                    .Buttons({
                        fundingSource: paypal.FUNDING.PAYPAL,

                        createBillingAgreement: function () {
                            return paypalCheckoutInstance.createPayment({
                                flow: 'vault', // Required
                            });
                        },

                        onShippingChange: function (data, actions) {
                            return actions.resolve();
                        },

                        onApprove: async function (data) {
                            try {
                                const payload =
                                    await paypalCheckoutInstance.tokenizePayment(
                                        data
                                    );

                                await braintreeAddPaymentMethod({
                                    nonce: payload.nonce,
                                    card_additional_information:
                                        cardAdditionalInfo.value,
                                });

                                emit('close');
                            } catch (err) {
                                create({
                                    title: 'Payment method not added',
                                    text: 'There has been an error adding your payment method.',
                                    type: 'error',
                                });
                            }
                        },

                        onCancel: function (data) {
                            console.log(
                                'PayPal payment canceled',
                                JSON.stringify(data, 0, 2)
                            );
                        },

                        onError: function (err) {
                            console.error('PayPal error', err);
                        },
                    })
                    .render('#paypal-button');
            })
            .then(function () {
                // The PayPal button will be rendered in an html element with the ID
                // 'paypal-button'. This function will be called when the PayPal button
                // is set up and ready to be used
            })
            .catch(function (err) {
                throw err;
            });
    } catch (err) {
        return;
    }
}

const saveCard = async () => {
    loading.value = true;
    try {
        if (isStripeEnabled) {
            await saveStripeCard();
        } else {
            await saveBraintreeCard();
        }
        emit('close');
    } catch (e) {
        create({
            title: 'Payment method not added',
            text:
                e instanceof Error
                    ? e.message
                    : 'There has been an error adding your payment method.',
            type: 'error',
        });
    } finally {
        loading.value = false;
    }
};

const saveBraintreeCard = async () => {
    const response = await braintreeVerifyCard({
        card_additional_information: cardAdditionalInfo.value,
    });

    await braintreeAddPaymentMethod({
        nonce: response.nonce,
        card_additional_information: cardAdditionalInfo.value,
    });
};

const saveStripeCard = async () => {
    await stripeAddPaymentMethod({
        name:
            cardAdditionalInformation.value.given_name +
            ' ' +
            cardAdditionalInformation.value.surname,
        country: cardAdditionalInformation.value.country_code ?? '',
        postal_code: cardAdditionalInformation.value.postal_code ?? '',
    });
};
</script>

<style scoped>
div.braintree-hosted-fields-focused {
    border: 1px solid #63b3ed;
}

div.braintree-hosted-fields-invalid {
    border: 1px solid #e02424;
}
</style>
